module.exports = "/_next/static/images/DeliverUnifiedCustomerExperiences-462ebe115564e21a4f9d28d2a36a1897.webp";